import { feedSubjectIds } from './league-feed';

export {
  CONGRATS_SEEN_EVENT,
  congratsSince,
  readCongratsSeen,
  saveCongratsSeen,
} from './feed-congrats-seen';

const REACTABLE = ['katildi', 'mac_sonucu', 'kilometre_tasi', 'gonderi'];
const RETURN_DAYS = 14;
const MAX_RETURN_ROWS = 2;

/**
 * Ç1 akış satırları: seni (son 14 günde) tebrik edenlerin, henüz tebrik etmediğin son kartı. En çok 2.
 * `selected`: izleyicinin karttaki tebrik durumu (bilinmiyorsa undefined; o kart önerilmez).
 * `kept`: bu ziyarette karşılık verilen kartlar listede kalır ("Tebrik ettin").
 */
export function returnCongratsRows(
  events: LeagueFeed.Event[],
  viewerId: string,
  // eslint-disable-next-line no-unused-vars -- callback type signature
  selected: (event: LeagueFeed.Event) => boolean | undefined,
  now = Date.now(),
  kept: string[] = [],
): { reactor: LeagueFeed.Reactor; event: LeagueFeed.Event }[] {
  const since = now - RETURN_DAYS * 24 * 3600 * 1000;
  const reactable = events.filter(
    event => REACTABLE.includes(event.tur) && event.olusturma >= since,
  );
  const seen = new Set<string>();
  const rows: { reactor: LeagueFeed.Reactor; event: LeagueFeed.Event }[] = [];
  reactable
    .filter(event => feedSubjectIds(event).includes(viewerId))
    .forEach(event =>
      (event.tebrik_onizleme || []).forEach(reactor => {
        if (reactor.id === viewerId || seen.has(reactor.id) || rows.length >= MAX_RETURN_ROWS)
          return;
        seen.add(reactor.id);
        const target = reactable.find(
          item =>
            feedSubjectIds(item).includes(reactor.id) &&
            !feedSubjectIds(item).includes(viewerId) &&
            (selected(item) === false || kept.includes(item.id)),
        );
        if (target) rows.push({ reactor, event: target });
      }),
    );
  return rows;
}
